export default '2.24.0';
